import { useQuery } from "@tanstack/react-query"
import { EnderecoService } from "../../../../../Services/EnderecoService";
import Select from "antd/lib/select";
import { SelectComPesquisa } from "../../../../SelectComPesquisa";

interface IMunicipioSelectProps extends Omit<React.ComponentProps<typeof Select>, | "showSearch" | "optionFilterProp" | "filterOption"> {
    codEstado?: number;
}

export default function MunicipioSelect({
    codEstado,
    placeholder,
    disabled,
    ...rest
}: IMunicipioSelectProps) {
    const enderecoService = new EnderecoService();

    const {
        isLoading,
        isError,
        data
    } = useQuery({
        queryKey: ["listarMunicipios", `listarMunicipios.${codEstado}`],
        queryFn: () => enderecoService.listarMunicipios({ codigo: codEstado }),
        enabled: codEstado !== undefined && codEstado !== null && !isNaN(codEstado) && codEstado > 0
    })


    return <SelectComPesquisa
        {...rest}
        loading={isLoading}
        disabled={isError || disabled}
        options={data?.data.map((item) => ({
            value: item.codigo,
            label: item.nome
        }))}
        placeholder={placeholder ?? "Selecione"}
    />
}